import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseCountry } from '@/shared/converters/countryConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import { getCountryTelCode, getDefaultCountryId } from '@/shared/models/Country';
import { PhoneNumber } from '@/shared/models/common';
import Customer from '../models/Customer';

const SCHEMA = {
  id: (data: any) => data.userId ?? data.id,
  dealerCustomerDataId: 'dealerCustomerDataId',
  type: 'type',
  title: 'title',
  firstName: 'firstName',
  lastName: 'lastName',
  fullName: (data: any) => data.fullname || data.fullName || data.name || data.customerName || data.createdBy,
  avatar: (data: any) => data.customerAvatar || data.profileImageGUID || data.profilePicture,
  email: (data: any) => data.firstEmail || data.email,
  secondEmail: 'secondEmail',
  thirdEmail: 'thirdEmail',
  phone: (data: any) => parsePhoneNumber(data.firstPhoneNumber || data.phoneNumber, data.country),
  secondPhone: (data: any) => parsePhoneNumber(data.secondPhoneNumber || data.phoneNumber2, data.country),
  mobilePhone: (data: any) => parsePhoneNumber(data.firstMobileNumber, data.country),
  secondMobilePhone: (data: any) => parsePhoneNumber(data.secondMobileNumber, data.country),
  address: 'address',
  houseNumber: 'houseNumber',
  zipCode: 'zipCode',
  city: 'city',
  language: 'language',
  optOut: 'optOut',
  optOutOn: (data: any) => parseMoment(data.optOutOn),
  emailOptIn: 'emailOptIn',
  emailOptInOn: (data: any) => parseMoment(data.emailOptInOn),
  smsOptIn: 'smsOptIn',
  smsOptInOn: (data: any) => parseMoment(data.smsOptInOn),
  optinDealerPhone: 'optinDealerPhone',
  optinDealerEmail: 'optinDealerEmail',
  optinDealerSMS: 'optinDealerSMS',
  optinDealerPost: 'optinDealerPost',
  vat: 'vatNumber',
  isActive: 'isActive',
  isDeleted: 'isDeleted',
  isCustomer: (data: any) => data.isCustomer ?? true,
  country: (data: any) => parseCountry(data.country),
  birthdate: (data: any) => parseMoment(data.birthdate ?? data.birthday),
};

export function parseCustomer(data: any): Customer | null {
  return parseEntity(data, SCHEMA, Customer);
}

export function parseCustomers(data: any): Array<Customer> {
  return parseEntities(data, SCHEMA, Customer);
}

function parsePhoneNumber(phoneNumber: any, country: any): PhoneNumber | null {
  if (typeof phoneNumber !== 'string') return null;
  if (phoneNumber.startsWith('00')) {
    return phoneNumber.replace('00', '+');
  } else if (phoneNumber.startsWith('0')) {
    return phoneNumber.replace('0', getCountryTelCode(country?.id ?? getDefaultCountryId()) || '0');
  } else {
    return phoneNumber;
  }
}